/* eslint-disable no-irregular-whitespace */
import { Badge, Button } from "antd";
import { useEffect, useState } from "react";
import FastMarquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../../context/LoginContext";
import { envChangeType } from "../../../../plugins/utils";
import { usePopupContext } from "../../context/PopupContext";
import MarqueeIcon from "../../icons/Marquee";
import styles from "./styleModule";
function Marquee({
  isHidden = false,
  showNotification = false,
  showDownload = false,
  customImage = null,
  customMarqueeContainerStyle = {},
  marqueeTextContainerStyle = "",
}) {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { checkIfLogin } = useLogin();
  const { data } = usePopupContext();
  const [isHaveNewMessage, setIsHaveNewMessage] = useState(false);
  const [notice, setNotice] = useState("");

  // const { data: message } = useGetMessage({
  //   enabled: !!isLogin && showNotification === true,
  // });

  //1bbetv2
  // const checkNewMessage = () => {
  //   if (!message) return;
  //   const found = message.find((r) => r.read_status === 0);
  //   if (found) {
  //     setIsHaveNewMesssage(true);
  //   } else {
  //     setIsHaveNewMesssage(false);
  //   }
  // };

  // useEffect(() => {
  //   checkNewMessage();
  // }, [message]);
  //1bbetv2

  const getMarquee = () => {
    const result = data?.filter((item) => item.position == 2);
    if (!!result) {
      const regex = /(<([^>]+)>)/gi;
      let processNotice = result?.map((n) => {
        return n.content.replace(regex, "");
      });
      if (processNotice.length === 1) {
        setNotice(
          `${processNotice[0]}\u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0`,
        );
      } else {
        setNotice(
          processNotice?.join(
            "\u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0",
          ),
        );
      }
    }
  };

  useEffect(() => {
    //visible even if not loggedin
    if (!!data) {
      getMarquee();
    }
  }, [data]);

  const renderMessage = () => {
    if (customImage) return customImage;
    return <MarqueeIcon />;
  };

  const renderNotification = () => {
    if (showNotification === false) return null;
    return (
      <div
        onClick={() => {
          if (!checkIfLogin()) return;
          navigate("/notice");
        }}
        style={{ display: "flex", alignItems: "center", padding: 0, width: 22 }}
      >
        <Badge dot={isHaveNewMessage} offset={[-4, 3]} style={{ width: "8px", height: "8px" }}>
          <img
            src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/notification_icon.svg`}
            alt="notification"
          />
        </Badge>
      </div>
    );
  };

  const renderDownload = () => {
    if (showDownload === false) return null;
    return (
      <div
        className={styles.downloadContainer}
        onClick={() => {
          navigate("/appDownload");
        }}
      >
        <img
          src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/download_icon.svg`}
          alt="download"
        />
        <div className={styles.downloadText}>APP</div>
      </div>
    );
  };

  return (
    <div
      className={`${styles.marquee} ${isHidden ? styles.hidden : ""}`}
      style={customMarqueeContainerStyle}
    >
      <Button
        type="link"
        onClick={() => {
          if (!checkIfLogin()) return;
          navigate("/announce");
        }}
        style={{ display: "flex", alignItems: "center", padding: 0, width: 22 }}
      >
        {renderMessage()}
      </Button>
      <div className={`${styles.marqueeTextContainer} ${marqueeTextContainerStyle}`}>
        <FastMarquee delay={2} speed={80}>
          {notice}
        </FastMarquee>
      </div>
      {renderNotification()}
      {renderDownload()}
    </div>
  );
}

export default Marquee;
